import React from 'react';
// eslint-disable-next-line import/no-unassigned-import
import '../../corecss/homeCore.css';
import pageStyles from '../../index.less';
import { HeroBlock } from '../../components/heroblock/HeroBlock';
import { HomePageContents } from '../../components/homePageContents/HomePageContents';
import { useAppDispatch, useAppSelector } from '../../store/store';
import tabs from '../../components/heroblock/tabNames';
import { setBranchenbuchSearch as _setBranchenbuchSearch } from '../../actions/branchenbuchSearch';
var Home = function Home() {
  var dispatch = useAppDispatch();
  var apiEndPoint = useAppSelector(function (state) {
    return state.config.API_ENDPOINT;
  });
  var isBranchenbuchSearch = useAppSelector(function (state) {
    var _state$branchenbuchSe, _state$branchenbuchSe2;
    return (_state$branchenbuchSe = (_state$branchenbuchSe2 = state.branchenbuchSearch) === null || _state$branchenbuchSe2 === void 0 ? void 0 : _state$branchenbuchSe2.isBranchenbuchSearch) !== null && _state$branchenbuchSe !== void 0 ? _state$branchenbuchSe : false;
  });
  var selectedTab = isBranchenbuchSearch ? tabs.TAB2 : tabs.TAB1;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(pageStyles.mainPageStyle, " padding-none")
  }, /*#__PURE__*/React.createElement(HeroBlock, {
    apiEndPoint: apiEndPoint,
    selectedTab: selectedTab,
    setBranchenbuchSearch: function setBranchenbuchSearch(value) {
      return dispatch(_setBranchenbuchSearch(value));
    }
  }), /*#__PURE__*/React.createElement(HomePageContents, {
    isBranchenbuch: isBranchenbuchSearch
  }));
};
export default Home;